export default __webpack_public_path__ + "static/media/projTrack5Full.41654dd8.png";